import { EventName } from "./analytics/event-names.js";
import { faqSchemaTypes } from "./constants/faq-schema-type.js";
import { getIsDebug } from "./debug/is-debug.js";
import { validateDependencyProvenance } from "./dependency/provenance.js";
import { assertEnv } from "./env/assert-env.js";
import isDevOrPreview from "./env/is-dev-or-preview.js";
import { isTruthyEnvValue } from "./env/is-truthy-env-value.js";
import { convertErrorForLogging } from "./logging/convert-error-for-logging.js";
import { isRecord } from "./object/is-record.js";
import { log, logDebug, logError, logInfo, logWarn } from "./logging/logger.js";
import "./logging/index.js";
import { formatPartialPhoneNumber } from "./phone/format-partial-phone-number.js";
import { formatPhoneDisplay } from "./phone/format-phone-display.js";
import { formatPhoneForTel } from "./phone/format-phone-for-tel.js";
import { normalizePhone } from "./phone/normalize-phone.js";
import { normalizeNanpGeoSearchTerm } from "./postal/normalize-nanp-geo-search-term.js";
import { normalizePostalCode } from "./postal/normalize-postal-code.js";
import { emailRegex } from "./regex/email.js";
import { hasSegmentInPath } from "./url/has-segment-in-path.js";
import { RESTRICTED_URL_SEGMENTS, hasRestrictedSegment } from "./seo/has-restricted-segment.js";
import { escapeHtmlAttribute } from "./string/escape-html-attribute.js";
import { kebabToCamel } from "./string/kebab-to-camel.js";
import { trimToOptionalString } from "./string/trim-to-optional-string.js";
import { appendQueryParamToUrl } from "./url/append-query-param-to-url.js";
import { getAffiliateRefIdFromSearchString } from "./url/get-affiliate-ref-id-from-search-string.js";
import { isFountainUrl } from "./url/is-fountain-url.js";
import { normalizeUrl } from "./url/normalize-url.js";
import { scrollToTop } from "./window/scroll.js";

export { EventName, RESTRICTED_URL_SEGMENTS, appendQueryParamToUrl, assertEnv, convertErrorForLogging, emailRegex, escapeHtmlAttribute, faqSchemaTypes, formatPartialPhoneNumber, formatPhoneDisplay, formatPhoneForTel, getAffiliateRefIdFromSearchString, getIsDebug, hasRestrictedSegment, hasSegmentInPath, isDevOrPreview, isFountainUrl, isRecord, isTruthyEnvValue, kebabToCamel, log, logDebug, logError, logInfo, logWarn, normalizeNanpGeoSearchTerm, normalizePhone, normalizePostalCode, normalizeUrl, scrollToTop, trimToOptionalString, validateDependencyProvenance };